import React, { Fragment } from 'react';
import _ from 'lodash';
import Wait from './Wait';
import Button from 'material-ui/Button';
import ArrowUp from 'material-ui-icons/ArrowUpward';
import ArrowDown from 'material-ui-icons/ArrowDownward';
import SearchIcon from 'material-ui-icons/Search';
import Select from './Select';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';

const SORT_COLUMN_OPTIONS = [
	{ value:"lastModified", label: "Date"},
	{ value:"id",      label: "ID"},
	{ value:"type",     label: "File Type"},
	{ value:"size",    label: "Size"},
	{ value:"name",     label: "File Name"},
];

export default class MediaManager extends React.Component {

	get app(){
		return this.props.app;
	}

	get files(){
		return this.app.mediaManager.files;
	}

	get sortedFiles(){
		let rows = this.files || [];
		rows = this.app.fuzzyMatch(rows, this.app.mediaManager.search, row => row.name )
		if(this.app.mediaManager.chipFilter){
			rows = rows.filter( row => {
				return row.type === this.app.mediaManager.chipFilter
			});
		}
		rows = _.sortBy(rows, row => {
			let sortField = this.app.mediaManager.sortColumn || 'lastModified';
			return (row[sortField] && row[sortField].toLowerCase) ? row[sortField].toLowerCase() : row[sortField];
		})
		if(!this.app.mediaManager.sortAscending){
			rows.reverse();
		}
		return rows;
	}

	render(){

		let files = this.sortedFiles;

		const currentElement = this.app.experiment.currentElement;

		return (
			<Fragment>
				<div >
					<StatusChip label="ALL" value="" app={this.app} />
					<StatusChip label="IMAGES" value="image" app={this.app} />
					<StatusChip label="VIDEOS" value="video" app={this.app} />
					<StatusChip label="AUDIO" value="audio" app={this.app} />
					
					<TextField
						label={<SearchIcon />}
						id="search"
						value={this.app.mediaManager.search || ''}
						onChange={ e => {this.app.mediaManager.search = e.currentTarget.value; this.app.forceUpdate()} }
						margin="normal"
						style={{width:'120px', marginLeft:'7px'}}
						/>
					&nbsp;&nbsp;
					<Select
						label="Sort by"
						id="sortColumn"
						value={this.app.mediaManager.sortColumn}
						onChange={ o =>{ this.app.mediaManager.sortColumn = o.value; this.app.forceUpdate(); } }
						options={SORT_COLUMN_OPTIONS}
						/>

					<div 
						onClick={  o =>{ this.app.mediaManager.sortAscending = !this.app.mediaManager.sortAscending; this.app.forceUpdate(); } }
						style={{display:'inline-block', position: 'relative',top: '7px', paddingLeft: '7px'}}>
						{ !!this.app.mediaManager.sortAscending ? <ArrowUp /> : <ArrowDown /> }
					</div>
				</div>

				<div style={{display:'flex'}}>
				{files && 
					<table className="MediaTable" style={{flex:1}}>
						<thead>
							<tr> 
								<th>PREVIEW</th>
								<th>DETAILS</th>
								<th>ID <span style={{fontStyle:'italic'}}>(must be unique)</span></th>
							</tr>
						</thead>
						<tbody>
							{ files.map( (file) =>
								<tr key={file.name}> 
									<td className="MediaTable-mediaCell">
										{file.type === 'image' && <img src={file.url} alt="experiment asset" />}
										{file.type === 'video' && <video src={file.url} controls />}
										{file.type === 'audio' && <audio src={file.url} controls />}
									</td>
									<td>
										<div style={{display:'flex'}}>
											<div style={{margin:'0px 20px 0 15px'}}>
												<Button onClick={ e => {this.app.experiment.addElement(file.type, file); this.app.closeFullScreenDialog();}} variant='raised' color='primary'>Add To Screen</Button><br />
												{ !!(currentElement && currentElement.type === file.type) && <a onClick={ e => {this.app.experiment.replaceElement(file.type, file); this.app.closeFullScreenDialog();}} style={{display:'inline-block', marginTop:'15px', marginLeft:'2px'}} variant='flat'>Replace selected item</a>}
											</div>
											<div>
												{file.name}
												<div className="MediaTable-mediaSize">{file.sizeLabel}</div>
												<div className="MediaTable-mediaDate">{file.lastModified.format('lll')}</div>
												<a onClick={() => {this.app.mediaManager.deleteMedia(file);} }>Delete</a>
											</div>
										</div>
									</td>
									<td className="MediaTable-inputCell"><TableInput file={file} mediaSet={this.props.app.experiment.data.mediaSet}/></td>
								</tr>
							)}
						</tbody>
					</table> 
				}

					<div>
						<div className="instructions" style={{width:'300px', marginLeft:'15px'}}>
							Drag in files or <a onClick={(e)=>{ document.querySelector('.MediaManager-drag-input').click(); }}>click here</a> to upload.
							<ul>
								<li>If you upload a file with the same name as an existing file, it will replace the file.</li> 
								<li>The ID is used to reference your media within a project. IDs need to be unique.</li>
								<li>
									Supported formats:
									<br /><br />
									<ul>
										<li>Images: jpg, png, gif</li>
										<li>Audio: mp3</li>
										<li>Videos: mp4, ogg, webm</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>


				<style dangerouslySetInnerHTML={{__html: `
					.datasetInput, .Dataset-drag-bg { display:none !important; }
				`}} />
				{ !!this.app.mediaManager.loading && <Wait />}
			</Fragment>
		);
	}
}


class TableInput extends React.Component{

	render(){
		let {file, mediaSet} = this.props;
		return (
			<input type="text" defaultValue={file.id} onBlur={e =>  { 
					if(e.currentTarget.value){
						mediaSet[file.name] = e.currentTarget.value;
					}else{
						delete mediaSet[file.name];
					}

					e.currentTarget.value = file.id;
					
					this.forceUpdate()
					}} />
		);
	}
}


const StatusChip = ({app, label, value }) => (
	<Chip
		style={{margin:'0px 5px'}}
		id={`status-chip-${value}`}
		label={label}
		onClick={ e => {app.mediaManager.chipFilter = value; app.forceUpdate()} }
		className={app.mediaManager.chipFilter === value ? 'selected-chip' : undefined}
		/>
);


// WEBPACK FOOTER //
// ./src/components/MediaManager.js